import { useState, useCallback } from 'react';

export const useActiveIndex = (maxIndex: number) => {
  const [index, setIndex] = useState<number>(-1);

  const indexUp = useCallback(() => {
    setIndex((prev) => {
      if (prev - 1 < -1) return -1;
      return prev - 1;
    });
  }, []);

  const indexDown = useCallback(() => {
    setIndex((prev) => {
      if (prev + 1 > maxIndex) return prev;
      return prev + 1;
    });
  }, [maxIndex]);

  return {
    index,
    setIndex,
    indexUp,
    indexDown,
  };
};
